import React from 'react';
import ContactForm from '../ContactFrom'; // Ensure the file name is correctly spelled
import { useTranslation } from 'react-i18next';

const Contactpage = ({ isLoading, error, contact }) => {
    const { t } = useTranslation();
    console.log(contact)
    return (
        <section className="wpo-contact-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-10 offset-lg-1">
                        <div className="office-info">
                            <div className="row">
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-location"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>{t('contactPage.address')}</h2>
                                            <p>{contact?.firstAddress}</p>
                                            <p>{contact?.secondAddress}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-email"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>{t('contactPage.emailUs')}</h2>
                                            <p>{contact?.firstEmail}</p>
                                            <p>{contact?.secondEmail}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-telephone"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>{t('contactPage.callNow')}</h2>
                                            <p>{contact?.firstPhoneNumber}</p>
                                            <p>{contact?.secondPhoneNumber}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wpo-contact-title">
                            <h2>{t('contactPage.haveAnyQuestion')}</h2>
                            <p>{t('contactPage.contactDescription')}</p>
                        </div>
                        <div className="wpo-contact-form-area">
                            <ContactForm />
                        </div>
                    </div>
                </div>
            </div>
            <section className="wpo-contact-map-section">
                <div className="wpo-contact-map">
                    <iframe
                        src={contact?.mainGoogleMapsLink}
                        title="Google Map"
                    ></iframe>
                </div>
            </section>
        </section>
    );
};

export default Contactpage;
